import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";

import Index from "../pages/vehicle/index";
import WorkshopMasterLayout from "../layout/WorkshopMasterLayout";


const WorkshopPrivateRoutes = () => {
        const [liftingName, setLiftingName] = useState<any>('')
    
    return (
        <>
            <Routes>
                        <Route element={<WorkshopMasterLayout liftingName={liftingName}/>}>

                    <Route path="vehicle/*" element={<Index setLiftingName={setLiftingName}/>}/>
                </Route>

            </Routes>
        </>
    );
};

export default WorkshopPrivateRoutes;